import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import 'antd/dist/antd.css';
import './style.css';
ReactDOM.render(React.createElement(App, null), document.getElementById('root'));